import * as React from "react";
import { GoogleAnalyticsService } from "../services/ga";

export const useGoogleInit = (accessToken: string) => {
  const [ready, setReady] = React.useState<boolean>(false);
  const doAuth = () => {
    if (GoogleAnalyticsService.auth() && accessToken) {
      GoogleAnalyticsService.auth().authorize({ serverAuth: { access_token: accessToken } });
    }
  };
  const init = () => {
    GoogleAnalyticsService.analytics().ready(() => {
      const authResponse = GoogleAnalyticsService.auth().getAuthResponse();
      if (!authResponse) {
        doAuth();
        GoogleAnalyticsService.auth().on("success", () => {
          setReady(true);
        });
      } else {
        setReady(true);
      }
    });
  };
  React.useEffect(() => init(), [accessToken]);
  return [ready];
}


// WEBPACK FOOTER //
// ./src/share/hooks/useGoogleInit.ts